module.exports = __webpack_public_path__ + "assets/img/btn-view-a8050944.png";